<template>
  <v-container id="docForm" style="max-width: 1500px">
    <!-- first card -->
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Orders On Hold</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="primary" to="/pos"><v-icon left>mdi-keyboard-backspace</v-icon>Back</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
            orders on hold
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>